import { useChainedCommands, useActive, useEditorView } from '@remirror/react';
import React, { useCallback, useMemo, useState } from 'react';
import CommandButton from '../CommandButton';
import { ColorPicker, Popover, theme } from 'antd';
import './TextHighlightButton.css';

const { useToken } = theme;

const getSuggestedColors = (token) => [
  {
    colors: [token.colorBgBase, '#DCDFE4', '#C6EDFB', '#D3F1A7', '#F5E989', '#FDD0EC', '#EED7FC'],
  },
];

export function TextHighlightButton() {
  const active = useActive();
  const { token } = useToken();
  const commands = useChainedCommands();
  const [open, setOpen] = useState(false);
  const selection = useEditorView()?.state?.selection;

  const handleColorClick = useCallback(
    (factory) => {
      const color = factory?.metaColor?.toHexString() || token.colorText;
      if (color == token.colorText) {
        commands.focus().removeTextHighlight().run();
      } else {
        commands.setTextHighlight(color).focus().run();
      }
    },
    [setOpen]
  );

  const presets = useMemo(() => {
    return [...getSuggestedColors(token)];
  }, [token.colorPrimary]);

  const activeColor = useMemo(() => {
    let color = token.colorBgBase;
    Object.entries(presets).map(([_, { colors }]) => {
      colors?.forEach((value) => {
        if (typeof value !== 'string') value = value?.metaColor?.toHexString();
        if (active.textHighlight({ highlight: String(value).toLowerCase() })) color = value;
      });
    });
    return color;
  }, [selection]);

  return (
    <>
      <CommandButton onClick={() => setOpen((prev) => !prev)} enabled={true}>
        <ColorPicker
          rootClassName="cms__color__picker color-highlight"
          showText={false}
          disabledAlpha={true}
          disabledFormat={true}
          format="hex"
          arrow={false}
          presets={presets}
          size={'small'}
          value={activeColor}
          open={open}
          panelRender={(_, { components }) => {
            const { Presets } = components;
            return <Presets />;
          }}
          onChange={handleColorClick}
        />{' '}
        Highlight
      </CommandButton>
    </>
  );
}

export default React.memo(TextHighlightButton);
